/* eslint-disable */
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// Chakra imports
import {
    Box,
    Button,
    Flex,
    FormControl,
    Heading,
    Input,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import axios from "axios";
import { ENDPOINTS } from "utils/Constants";
// Custom components
import DefaultAuth from "layouts/auth/Default";
import { notify } from "components/ToastNotification";
// Assets
import illustration from "assets/img/auth/auth.png";

function ResetPassword() {

    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token"); 

    const [formData, setFormData] = React.useState({
        newPassword: "",
        confirmPassword: "",
    });

    useEffect(() => {
        if (!token) {
            notify("Invalid or missing token. Please try again.", "error");
            navigate("/auth/sign-in"); 
        }
    }, [token, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { newPassword, confirmPassword } = formData;

        if (!newPassword.trim() || !confirmPassword.trim()) {
            notify("Please fill in all fields.", "warning");
            return;
        }

        if (newPassword !== confirmPassword) {
            notify("Passwords do not match.", "error");
            return;
        }

        try {
            const response = await axios.post(ENDPOINTS.RESET_PASSWORD, { 
                newPassword, 
                token 
            });
            const responseData = response.data;
            notify(responseData.output, responseData.success ? "success" : "error");

            if (responseData.success) {

                setFormData({ newPassword: "", confirmPassword: "" });

                navigate("/auth/sign-in");
            }
        } catch (error) {
            if (error.response?.data) {
                const response = error.response?.data;
                notify(response.output, response.success ? "success" : "error");
            }
        }
    };

    return (
        <DefaultAuth illustrationBackground={illustration} image={illustration}>
            <Flex
                maxW={{ base: "100%", md: "max-content" }}
                w="100%"
                mx={{ base: "auto", lg: "0px" }}
                me="auto"
                h="100%"
                alignItems="start"
                justifyContent="center"
                mb={{ base: "30px", md: "60px" }}
                px={{ base: "25px", md: "0px" }}
                mt={{ base: "40px", md: "14vh" }}
                flexDirection="column"
            >
                <Box me="auto">
                    <Heading color={textColor} fontSize="36px" mb="10px">
                        Reset Password
                    </Heading>
                    <Text
                        mb="36px"
                        ms="4px"
                        color={textColorSecondary}
                        fontWeight="400"
                        fontSize="md"
                    >
                        Enter your new password.
                    </Text>
                </Box>
                <Flex
                    zIndex="2"
                    direction="column"
                    w={{ base: "100%", md: "420px" }}
                    maxW="100%"
                    background="transparent"
                    borderRadius="15px"
                    mx={{ base: "auto", lg: "unset" }}
                    me="auto"
                    mb={{ base: "20px", md: "auto" }}
                >
                    <form onSubmit={handleSubmit}>
                        <FormControl mb="24px">
                            <Input
                                isRequired
                                variant="auth"
                                fontSize="sm"
                                type="password"
                                placeholder="New Password*"
                                fontWeight="500"
                                size="lg"
                                name="newPassword"
                                value={formData.newPassword}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl mb="24px">
                            <Input
                                isRequired
                                variant="auth"
                                fontSize="sm"
                                type="password"
                                placeholder="Confirm Password*"
                                fontWeight="500"
                                size="lg"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <Button
                            fontSize="sm"
                            variant="brand"
                            fontWeight="500"
                            type="submit"
                            w="100%"
                            h="50"
                        >
                            Reset Password
                        </Button>
                    </form>
                </Flex>
            </Flex>
        </DefaultAuth>
    );
}

export default ResetPassword;
